import { label } from "../config";

/**
 * Formats user status display with custom status message
 * @param {string} availabilityStatus - The availability status (Available/Away)
 * @param {string} customStatus - Optional custom status message
 * @param {number} maxLength - Maximum length for custom status before truncation (default: 20)
 * @returns {Object} Object with formatted status string and full status for tooltip
 * @author Muskan Thakur
 */
export const formatUserStatus = (availabilityStatus, customStatus = null, maxLength = 20) => {
  if (!availabilityStatus) {
    const status = label.AVAILABLE;
    return { display: status, full: status };
  }

  const normalizedStatus = availabilityStatus?.toString().trim();
  const statusText = normalizedStatus === label.AWAY ? label.AWAY : label.AVAILABLE;

  if (customStatus && customStatus.trim()) {
    const trimmedCustomStatus = customStatus.trim();
    const fullStatus = `${statusText} – ${trimmedCustomStatus}`;

    if (trimmedCustomStatus.length > maxLength) {
      const truncatedCustomStatus = trimmedCustomStatus.substring(0, maxLength) + "...";
      const displayStatus = `${statusText} – ${truncatedCustomStatus}`;
      return { display: displayStatus, full: fullStatus };
    }

    return { display: fullStatus, full: fullStatus };
  }

  const status = statusText;
  return { display: status, full: status };
};

/**
 * Gets the availability status from user object
 * @param {Object} user - User object
 * @returns {string} Availability status (Available/Away)
 * @author Muskan Thakur
 */
export const getAvailabilityStatus = (user) => {
  if (!user) return label.AVAILABLE;

  const status = user.availabilityStatus || user.StatusText;
  const normalizedStatus = status?.toString().trim();

  if (normalizedStatus === label.AWAY) {
    return label.AWAY;
  }
  return label.AVAILABLE;
};

/**
 * Gets custom status from user object
 * @param {Object} user - User object
 * @returns {string|null} Custom status message or null
 * @author Muskan Thakur
 */
export const getCustomStatus = (user) => {
  if (!user) return null;
  return user.customStatus || user.CustomStatus || null;
};
